import style from "./index.module.scss";
export default function Empty(props){
    return (
        <div className={style.empty} style={{paddingTop:props.marginTop}}>
            <img src={require("../../image/empty.jpg")} alt="" />
            <div>{props.text}</div>
        </div>
    )
}
